export default __webpack_public_path__ + "static/media/forestly-expl-nn-06_EN.06f94c9b.png";